import React, {FC, useState} from 'react'
import {Link, useNavigate} from 'react-router-dom'
import moment from 'moment'
import {useAppDispatch} from 'src/redux/storeHooks'
import {createSuperadminNewsAsync} from 'src/redux/actions/superadminNewsActions'
import useAppToast from 'src/hooks/useAppToast'
import NewsUpdateForm, {NewsUpdateFormValues} from './NewsUpdateForm'
import {buildNotificationPayload} from './newsPayload'
import './superadmin-news.scss'

const emptyForm = (): NewsUpdateFormValues => ({
  releaseDate: moment().format('YYYY-MM-DD'),
  heading: '',
  description: '',
  type: 'NEWS_ANNOUNCEMENTS',
})

const AddNewsUpdate: FC = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const {successToast, errorToast} = useAppToast()
  const [values, setValues] = useState<NewsUpdateFormValues>(emptyForm)
  const [submitting, setSubmitting] = useState(false)

  const handleChange = <K extends keyof NewsUpdateFormValues>(
    field: K,
    value: NewsUpdateFormValues[K]
  ) => {
    setValues((prev) => ({...prev, [field]: value}))
  }

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault()
    setSubmitting(true)

    dispatch(createSuperadminNewsAsync(buildNotificationPayload(values)))
      .then((response) => {
        if (response.payload?.status_code === 200 || response.payload?.status_code === 201) {
          successToast('Update published successfully.')
          navigate('/news-updates')
          return
        }
        errorToast(response.payload?.massage || response.payload?.message || 'Failed to publish update.')
      })
      .catch(() => errorToast('Failed to publish update.'))
      .finally(() => setSubmitting(false))
  }

  return (
    <div className='superadmin-news-page'>
      <div className='d-flex align-items-center justify-content-between mb-6'>
        <div>
          <h1 className='fs-2 fw-bold mb-1'>Add New Feature Update</h1>
          <p className='text-muted fs-7 mb-0'>Publish news and updates to the customer dashboard timeline.</p>
        </div>
        <Link to='/news-updates' className='btn btn-sm btn-light fw-semibold'>
          Back to List
        </Link>
      </div>

      <div className='card superadmin-news-form-card'>
        <div className='card-body p-8'>
          <NewsUpdateForm
            values={values}
            onChange={handleChange}
            onSubmit={handleSubmit}
            submitting={submitting}
          />
        </div>
      </div>
    </div>
  )
}

export default AddNewsUpdate
